exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".ymk-wrap {\n  min-width: 300px;\n  max-width: 600px;\n}\n.ymk-wrap .spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 3em;\n  font-size: 3em;\n  margin-left: -1.5em;\n  margin-top: -1.5em;\n  padding: 0.5em;\n}\n.ymk-wrap .spinner .icon-revive {\n  display: inline-block;\n  -webkit-transform-origin: 48.5% 55.5%;\n  -moz-transform-origin: 48.5% 55.5%;\n  -ms-transform-origin: 48.5% 55.5%;\n  transform-origin: 48.5% 55.5%;\n  font-size: 2em;\n}\n.ymk-wrap .spinner .icon-revive:before {\n  margin: 0;\n}\n", ""]);

// exports
